module.exports = __webpack_public_path__ + "img/alert.609a7e71.png";